import api from '../utils/api'; // Assuming you have an API utility

const roleService = {
  // Role CRUD
  getRoles: (params) => api.get('/admin/roles', { params }),
  getRole: (id) => api.get(`/admin/roles/${id}`),
  createRole: (data) => api.post('/admin/roles', data),
  updateRole: (id, data) => api.put(`/admin/roles/${id}`, data),
  deleteRole: (id) => api.delete(`/admin/roles/${id}`),
  
  // Role Permissions
  assignPermissions: (id, permissionIds) => 
    api.post(`/admin/roles/${id}/permissions`, { permissionIds }),
};

export default roleService;